<template>
  <div>
    <h1 class="display-5">{{ this.title }}</h1>
    <Statistics :statsData="statsData"></Statistics>
  </div>

</template>

<script>
import Statistics from '../../components/Statistics'

export default {
  name: "AdminDashboard",

  data() {
    return {
      show_validate_efedros: false,
      message_toast: "",
      statsData: {},
      title: "Πίνακας Διαχειριστή"
    }
  },
  components: {
    Statistics
  },
  computed: {
  },
  mounted() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('login', () => {
      });
      return;
    }

    this.$store.dispatch('loading')
    this.$store.dispatch('getStats')
    .then(res => {
      this.$store.dispatch('stop_loading')
      this.statsData = res.data
    })
    .catch(() => {
      this.$store.dispatch("stop_loading")
    })
  }
}
</script>

<style scoped>

</style>